<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap class="mt-3 mt-sm-0 mb-2">
      <v-flex xs12 sm8 md4 lg3>
        <h2 class="dark--text font-weight-bold">Online Refund History</h2>
      </v-flex>

      <v-flex xs12 sm8 md4 lg3>
        <v-select :items="['ALL', 'PENDING', 'REFUNDED', 'ERROR', 'REFUND_OFFLINE', 'CANCELLED']" solo dense attach item-text="method" item-value="_id" v-model="filter.status"></v-select
      ></v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 sm8 md4 lg3>
        <ExportRefund class="mt-n3" :refunds="refunds" :headers="headers" />
      </v-flex>
    </v-layout>

    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="refunds"
      class="elevation-1"
      :items-per-page="25"
      :options.sync="options"
      :loading="loading"
      :server-items-length="totalItems"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:item.customerId="{ item }">
        {{ item.customer.customerId }}
      </template>
      <template v-slot:item.phone="{ item }">
        {{ item.user.phone }}
      </template>
      <template v-slot:item.name="{ item }"> {{ item.user.firstnameEn }} {{ item.user.lastnameEn }} </template>
      <template v-slot:item.amount="{ item }">
        {{ numberWithCommas(item.amount) }}
      </template>
      <template v-slot:item.updatedBy="{ item }">
        <span v-if="item.updatedBy">{{ item.updatedBy.firstnameEn }} {{ item.updatedBy.lastnameEn }}</span>
      </template>
      <template v-slot:item.action="{ item }">
        <MarkAsRefunded v-if="item.status == 'PENDING'" :refund="item" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import MarkAsRefunded from "../components/MarkAsRefunded.vue";
import ExportRefund from "../components/ExportRefund.vue";
export default {
  components: { MarkAsRefunded, ExportRefund },

  mounted() {
    this.$root.$on("getAllOnlineRefund", () => {
      this.loading = true;
      this.getAllOnlineRefund();
    });
  },
  data: () => ({
    loading: true,
    totalItems: 25,
    refunds: [],
    options: {
      itemsPerPage: 25,
      page: 1,
    },
    filter: {
      status: "ALL",
    },
    headers: [
      {
        text: "Customer Id",
        value: "customerId",
        sortable: false,
        width: 80,
      },
      {
        text: "Phone",
        value: "phone",
        sortable: false,
        width: 120,
      },
      {
        text: "Name",
        value: "name",
        sortable: false,
        width: 200,
      },
      { text: "Amount", value: "amount", sortable: false, width: 100 },
      { text: "Status", value: "status", sortable: false, width: 120 },
      { text: "Reason", value: "reason", sortable: false, width: 200 },
      { text: "Updated By", value: "updatedBy", sortable: false, width: 150 },

      { text: "Action", value: "action", sortable: false, width: 80 },
    ],
  }),

  methods: {
    getAllOnlineRefund() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getAllOnlineRefund.graphql"),
          variables: {
            limit: 25,
            skip: 0,
            status: this.filter.status,
          },
        })
        .refetch({
          limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 200,
          skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
          status: this.filter.status,
        })
        .then(data => {
          this.loading = false;
          if (data.data.getAllOnlineRefund) {
            this.refunds = data.data.getAllOnlineRefund.onlineRefunds;
            this.totalItems = data.data.getAllOnlineRefund.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },
  watch: {
    options: {
      handler() {
        this.getAllOnlineRefund();
      },
      deep: true,
    },
    filter: {
      handler() {
        this.getAllOnlineRefund();
      },
      deep: true,
    },
  },
  created() {
    if (!this.hasRole(this.AdminUserPermissions.FAQ_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
  },
};
</script>
